import { Component, Input } from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';
import { OrderDetailModel } from '@cv-invision/cv.invision-intelligence.ux';
import { UcdpDetailsDialogComponent } from '../dialogs/ucdp-details-dialog/ucdp-details-dialog.component';

@Component({
	selector: 'cv-ucdp-details-button',
	templateUrl: './ucdp-button.component.html',
	host: {
		class: 'd-inline-flex align-items-center'
	}
})
export class UcdpDetailsButtonComponent {
	@Input() orderDetail: OrderDetailModel;

	constructor(private dialogService: DialogService) {}

	/**
	 * Triggers dialog when a pipeline element is clicked
	 * @param indicator
	 */
	openDialog() {
		this.dialogService.open(UcdpDetailsDialogComponent, {
			header: 'UCDP/EAD Submission',
			width: '1400px',
			height: '800px',
			data: {
				orderDetail: this.orderDetail
			}
		});
	}
}
